import { Pipe, PipeTransform } from '@angular/core';
import { TipoMovimentacao } from '../../models/movimentacao-cadastral/TipoMovimentacao';

@Pipe({
  name: 'badgeTipoMovimentacao',
})
export class BadgeTipoMovimentacaoPipe implements PipeTransform {
  transform(tipo: TipoMovimentacao): string {
    const labels = {
      0: 'bg-success text-light',
      1: 'bg-primary text-light',
      2: 'bg-danger text-light',
      3: 'bg-info text-dark',
      4: 'bg-warning text-dark',
    };

    return labels[tipo];
  }
}
